module.exports = __webpack_public_path__ + "static/img/safety.3b4dfdd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/safety.jpg
// module id = nyqd
// module chunks = 0